import { Card as AntCard, List } from 'antd'
import styled from 'styled-components'

import { Text } from 'src/components/Ant'

export const AgencyInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px;
  > :last-child {
    align-self: center;
    text-align: right;
    vertical-align: bottom;
  }
`

export const AirItem = styled(List.Item)`
  border: 1px solid #e8e8e8;
  margin: 24px 0;
  padding: 0;
`

export const AirWay = styled.div`
  align-items: center;
  border-top: 1px solid #e8e8e8;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  text-align: center;
  > :last-child {
    align-self: center;
    padding-right: 1rem;
    text-align: center;
  }
`

export const AirWayStep = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px;
`

export const AirWayStepItem = styled.div`
  align-content: space-around;
  display: grid;
  justify-items: center;
  line-height: normal;
`

export const Card = styled(AntCard)`
  margin-bottom: 16px;
`

export const CardTopDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px;
  > div {
    align-self: center;
    vertical-align: middle;
  }
`

export const Code = styled.div`
  padding-bottom: 4px;
  > span {
    font-size: 20px;
    margin-bottom: 12px;
    .anticon-copy {
      font-size: 12px;
      margin-right: 4px;
    }
  }
`

export const DivBordered = styled.div`
  border-bottom: 1px solid #e8e8e8;
`

export const DivStop = styled.div`
  align-self: center;
  text-align: center;
`

export const DivWay = styled.div`
  display: flex;
  justify-content: space-around;
  width: 18rem;
`

export const IconWhatsApp = styled.img`
  height: 20px;
  width: 20px;
  margin-left: 5px;
  cursor: pointer;
`

export const Plane = styled.img<{ color?: string }>`
  ${({ color }) => color && `background:${color}`};
  height: 1.25rem;
  margin-right: 0.5rem;
  width: 1.25rem;
`

export const Stops = styled(Text)<{ stops?: number }>`
  border-bottom: 2px solid ${({ stops }) => (!stops ? '#52c41a' : '#fa8c16')};
  font-size: 16px;
  font-weight: 600;
  padding: 0 4px 4px 4px;
  vertical-align: middle;
`

export const Time = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
`

export const ToCenter = styled.div`
  text-align: center;
`
